<div
  tabindex="0"
  class="account-details-panel"
  (blur)="onBlur($event)"
>
  <h2 class="account-details-panel__title">{{ user.attributes.name }}</h2>
  @if (roles.length) {
    <p class="account-details-panel__roles">{{ roles.join(', ') }}</p>
  }
  <div class="account-details-panel__contact">
    @if (user.attributes.email) {
      <p class="account-details-panel__line">{{ user.attributes.email }}</p>
    }
    @if (user.attributes.phone_number) {
      <p class="account-details-panel__line">{{ user.attributes.phone_number }}</p>
    }
  </div>
  <div class="account-details-panel__divider" role="separator"></div>
  <div class="account-details-panel__actions">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      class="account-details-panel__sign-out"
      (click)="signOut()"
    >
      <mat-icon>logout</mat-icon>
      <span>Sign out</span>
    </button>
  </div>
</div>
